import React, { useEffect, useRef, useState } from 'react'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert } from 'react-bootstrap';
import Editor, { Monaco } from "@monaco-editor/react";
import { editor } from 'monaco-editor';
import classNames from 'classnames';

type Props = {
  value?: any;
  onChange?: (value?: string) => void;
  language?: string;
  readOnly?: boolean;
  height?: string | number;
  onValidated?: (markers: editor.IMarker[]) => void;
  onBlur?: VoidFunction;
  className?: string;
}

export default function ScriptEditor({ value, onChange, language = 'json', readOnly, height = "65vh", onValidated, onBlur, className }: Props) {
  const editorRef = useRef<editor.IStandaloneCodeEditor | null>(null);
  const [editorValue, setEditorValue] = useState();

  useEffect(() => {
    setEditorValue(value ? typeof value !== 'string' && language === 'json' ? JSON.stringify(value, null, 2) : value : "");
  }, [value, language]);

  const handleBlur = () => onBlur ? onBlur() : null;
  const handleEditorDidMount = (editor: editor.IStandaloneCodeEditor, monaco: Monaco) => {
    editorRef.current = editor;

    setTimeout(() => {
      editorRef.current?.getAction('editor.action.formatDocument')
        ?.run()
        .then(
          () => {
            if (readOnly) editorRef.current?.updateOptions({ readOnly: readOnly })
          }
        );
    }, 100);

    monaco.editor.onDidChangeMarkers(([uri]) => {
      const markers = monaco.editor.getModelMarkers({ resource: uri })
      onValidated && onValidated(markers);
    });
  }

  const Loading = () => {
    return (
      <Alert>
        <FontAwesomeIcon icon={solid('spinner')} spin={true} />
        <span className="ms-2">Editor is loading...</span>
      </Alert>
    )
  }

  return (
    <div className={classNames("editor-wrapper", className)} onBlur={handleBlur}>
      <Editor
        height={height}
        theme="vs-dark"
        defaultLanguage={language}
        value={editorValue}
        loading={<Loading />}
        onMount={handleEditorDidMount}
        onChange={onChange}
      />
    </div>
  )
}
